import { render, staticRenderFns } from "./CustomIonInfiniteScroll.vue?vue&type=template&id=9c71210e&scoped=true"
import script from "./CustomIonInfiniteScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomIonInfiniteScroll.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomIonInfiniteScroll.vue?vue&type=style&index=0&id=9c71210e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c71210e",
  null
  
)

export default component.exports